import { Testimony } from '@/types';

export const testimonies: Testimony[] = [
  {
    key: 1,
    title: `Security peace of mind`,
    description: `The Pentester platform has gave us peace of mind when it comes to our security.`,
    review: 5,
    author: `Amish Patel`,
    authorPosition: `CPA`,
    avatarURL: `/img/avatars/amish.webp`,
  },
  {
    key: 2,
    title: `Simple for our staff to use`,
    description: `As a medical practice, the biggest challenge in the past has been finding a web based tool that our entire team can access and use. The Pentester Security Platform has done that.`,
    review: 5,
    author: `Harold Stein`,
    authorPosition: `MD`,
    avatarURL: `/img/avatars/harold.webp`,
  },
  {
    key: 3,
    title: `Ongoing scans provide reports`,
    description: `By using Pentester we have saved a considerable amount of time, and money. We rely on the reports and notifications.`,
    review: 5,
    author: `Brian Garmley`,
    authorPosition: `President`,
    avatarURL: `/img/avatars/brian.webp`,
  },
  {
    key: 4,
    title: `Powerfully simple for SAAS`,
    description: `Our development team has used Pentester since prior to our launch. It is definitely helpful for content discovery and to know what is out there.`,
    review: 5,
    author: `Markus Brady`,
    authorPosition: `Founder`,
    avatarURL: `/img/avatars/markus.webp`,
  },
  {
    key: 5,
    title: `Our firm loves Pentester`,
    description: `We didn't know prior to using the system the severity of what was going on. After our initial scan we had some work to do, and we appreciate the assistance from the Pentester team.`,
    review: 5,
    author: `John Sarlet`,
    authorPosition: `Lawyer`,
    avatarURL: `/img/avatars/john.webp`,
  },
  {
    key: 6,
    title: `Ransomware was our biggest concern`,
    description: `After the ADA put out a notice about the increase in ransomware in our industry, we knew we needed something immediately. We have had a great experience thusfar.`,
    review: 5,
    author: `Glenn Adams`,
    authorPosition: `Dentist`,
    avatarURL: `/img/avatars/glenn.webp`,
  },
];
